import React from 'react';
import Hero from './components/Hero';
import About from './components/About';
// import Job from './components/Job';
import './styles/global.css';
import Carousel from './components/Carousel';
// import Card from './components/Card';
import Footer from './components/Footer'
import Skills from './components/Skills';
import WorkExperience from './components/WorkExperience';




function App() {
  return (
    <div className="scroll-container">
      <Hero />
      <About />
      <Carousel />
      <WorkExperience />
      <Skills />
      <Footer />

    </div>
  );
}

export default App;
